<div id="members" class="tab-content active" >
    <div class="list">
        <div class="m" *ngIf="membersLoaded || labelUsers.length > 0">Connected company users</div>
        <div class="nh" *ngIf="membersLoaded || labelUsers.length > 0">Subscribe to e-mail alerts</div>
        <div class="ac" *ngIf="membersLoaded || labelUsers.length > 0"></div>

        <div class="grid-row titles" *ngIf="membersLoaded || labelUsers.length > 0">
            <div>Name</div>
            <div>Last Active</div>
            <div>User Role</div>
            <div>New distributions</div>
            <div>New repertoire</div>
            <div class="actions">Actions</div>
        </div>

        <div class="grid-row" *ngFor="let member of labelUsers; let i = index">
            <div class="n" [class.disabled-text]="member.userId === emptyId">
                <p *ngIf="member.userId === emptyId">Invite sent</p>
                <p *ngIf="member.userId !== emptyId">{{member.name || 'No name'}}</p>
                <h6>{{member.email}}</h6>
            </div>
            
            <div [class.disabled-text]="member.userId === emptyId">
                {{member.lastActive ? (member.lastActive | date : "d. MMM. yyyy") : '-'}}
            </div>
            
            <div>
                <select [id]="'dropdown' + i" 
                        name="options" 
                        [(ngModel)]="member.roleId"
                        [disabled]="member.userId === emptyId"
                        (change)="onMemberRoleChange(member, $event)">
                    <option *ngFor="let role of roles" [value]="role.id" [selected]="member.roleId === role.id">
                        {{role.name}}
                    </option>
                </select>
            </div>

            <!-- Financial Statements toggle -->
            <div [class.disabled-text]="member.userId === emptyId"
                 (click)="member.userId !== emptyId && toggleFinancialStatements(member)">
                <div class="t-c">
                    <div class="toggle-row">
                        <div class="toggle-switch">
                            <input type="checkbox" 
                                  [(ngModel)]="member.receiveFinancialStatements"
                                  [disabled]="member.userId === emptyId" />
                            <span class="ts"></span>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- New Reports toggle -->
            <div [class.disabled-text]="member.userId === emptyId"
                 (click)="member.userId !== emptyId && toggleNewReports(member)">
                <div class="t-c">
                    <div class="toggle-row">
                        <div class="toggle-switch">
                            <input type="checkbox" 
                                  [(ngModel)]="member.receiveNewReports"
                                  [disabled]="member.userId === emptyId" />
                            <span class="ts"></span>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="options">
                <button class="btn white submenu" 
                        [class.show]="activeSubmenu === member.email"
                        (click)="toggleSubmenu(member.email, $event)">
                    <img src="/assets/icons/three-dots-vertical.svg" alt="submenu">
                    <div class="subitems" (click)="onSubmenuClick($event)">
                        <a href="javascript:void(0)" 
                           *ngIf="member.userId === emptyId" 
                           (click)="resendInvitation(member)">Resend invitation</a>
                        <a href="javascript:void(0)"
                           *ngIf="member.userId === emptyId" 
                           (click)="deleteInvitation(member.invitationId)">Delete invitation</a>
                        <a href="javascript:void(0)"
                           *ngIf="member.userId !== emptyId" 
                           (click)="deleteMember(member.userId)">Delete member</a>
                    </div>
                </button>
            </div>
        </div>

        <!-- Show message when no members -->
        <div class="grid-row" *ngIf="labelUsers.length === 0">
            <div style="grid-column: 1 / -1; text-align: center; padding: 20px;">
                No users are connected to this label.
            </div>
        </div>
    </div>
</div>
